import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

// Modules
import app from '@/store/modules/app';


Vue.use(Vuex);

export default new Vuex.Store({

  strict: process.env.NODE_ENV !== 'production',
  plugins: [createPersistedState()],

  state: {
    // language: null,
  },
  mutations: {
    // language(state, value) {
    //   state.language = value
    // },
  },
  actions: {
  },
  modules: {
    app,
  }
});
